export default {
  KEY_TOKEN: 'gpuass_token',
  KEY_INFO: 'gpuass_info',
  KEY_LANG: 'gpuass_lang',
}
